var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 123,
    viewBox: "0 0 123 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 61.5,
    r: 61.5,
    fill: "#F4F6FE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 61.5,
    r: 45.5,
    fill: "#2D4BF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.1251 67.6258L52.021 62.5216C51.4522 61.9529 50.548 61.9529 49.9793 62.5216C49.4105 63.0904 49.4105 63.9945 49.9793 64.5633L56.0897 70.6737C56.6585 71.2424 57.5772 71.2424 58.146 70.6737L73.6043 55.2299C74.173 54.6612 74.173 53.757 73.6043 53.1883C73.0355 52.6195 72.1314 52.6195 71.5626 53.1883L57.1251 67.6258Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/Completed.fd84a5dd3f61ebd316ba3514582953fd.svg";
export { ForwardRef as ReactComponent };